function isValidArray(obj) {
    return Array.isArray(obj) && obj.length > 0;
}
/**
 * 深度优先遍历
 * @param node
 * @param fn
 */
export function dfs(node, callback) {
    let cur;
    let par;
    let children;
    let ctrl;
    let i;
    const nodes = Array.isArray(node) ? node.slice(0).reverse() : [node];
    const parents = [];
    const childrenName = 'children';
    if (typeof nodes[0] === 'undefined' && nodes.length === 1) {
        return;
    }
    for (i = nodes.length - 1; i >= 0; i--) {
        parents.push(undefined);
    }
    while (nodes.length > 0) {
        cur = nodes.pop();
        par = parents.pop();
        ctrl = {};
        callback.call(cur, cur, par, ctrl);
        if (ctrl.stop) {
            break;
        }
        children = cur && cur[childrenName] ? cur[childrenName] : [];
        for (i = ctrl.cutoff ? -1 : children.length - 1; i >= 0; i--) {
            nodes.push(children[i]);
            parents.push(cur);
        }
    }
    return node;
}
/**
 * 查找
 * @param node
 * @param fn
 */
export function find(tree, callback) {
    let found;
    dfs(tree, function (node, par, ctrl) {
        if (callback.call(node, node, par)) {
            ctrl.stop = true;
            found = this;
        }
    });
    return found;
}
/**
 * 根据执行条件过滤
 * @param tree
 * @param callback
 * @returns {[]}
 */
export function filter(tree, callback) {
    const rs = [];
    dfs(tree, (node, par) => {
        if (callback(node, par)) {
            rs.push(node);
        }
    });
    return rs;
}
export function getSiblings(tree, val) {
    let p;
    dfs(tree, (node, par) => {
        if (node.value === val) {
            p = par;
        }
    });
    if (!p) {
        return tree;
    }
    else {
        return filter(tree, (node, par) => {
            return par && par.value === p.value;
        });
    }
}
/**
 * 根据 value 数组，获取
 * @param tree
 * @param values
 */
export function getItemsFromDataSource(tree = [], values = []) {
    if (!(typeof values === 'undefined') && !Array.isArray(values)) {
        values = [values];
    }
    if (!isValidArray(tree) || !isValidArray(values)) {
        return [];
    }
    return values.map((val) => {
        return (find(tree, (it) => it.value === val) || {
            lavel: val,
            value: val,
        });
    });
}
/**
 * 获取第一个叶子节点
 * @param tree
 * @returns {[]|*[]}
 */
export function getFirstValue(tree = []) {
    const ret = [];
    if (!Array.isArray(tree) || tree.length === 0) {
        return ret;
    }
    let node = tree[0];
    do {
        if (node) {
            ret.push(node);
        }
        node =
            Array.isArray(node.children) && node.children.length > 0
                ? node.children[0]
                : null;
    } while (node);
    return ret.map((item) => item.value);
}
/**
 * 根据 传入的 tree ， 获取选中值列表的对应数据
 * @param data
 * @param value
 */
export function getDataByValues(tree = [], values = []) {
    const ret = [];
    const len = values.length;
    let child = tree;
    for (let i = 0; i < len; i++) {
        const val = values[i];
        const l = child.length;
        let flag = false;
        for (let j = 0; j < l; j++) {
            const item = child[j];
            if (item.value === val) {
                flag = true;
                if (Array.isArray(item.children)) {
                    child = item.children;
                }
                ret.push(item);
                break;
            }
        }
        if (!flag) {
            ret.push({
                label: val,
                value: val,
            });
        }
    }
    return ret;
}
/**
 * 根据节点，返回 path
 * @param tree
 * @param value
 */
export function getFullPathByValue(tree, value, key = 'value') {
    const path = [];
    const nodes = Array.isArray(tree) ? tree : [tree];
    function helper(node) {
        for (let i = 0; i < node.length; i++) {
            const item = node[i];
            if (item[key] === value) {
                path.push(value);
                return true;
            }
            if (item.children && helper(item.children)) {
                path.push(item[key]);
                return true;
            }
        }
        return false;
    }
    // 根节点的子元素
    helper(nodes);
    if (path.length > 0) {
        return path.reverse();
    }
    // 当没有匹配的path时，直接返回一个包含value的list
    return [value];
}
/**
 * 获取树的深度
 * @param treeData 数据源
 * @param childrenName 子数据的名称
 * @returns 树的深度
 */
export function getTreeDepth(treeData, childrenName = 'children') {
    const walker = (tree) => {
        let depth = 0;
        tree.forEach((item) => {
            if (item[childrenName]) {
                depth = Math.max(depth, walker(item[childrenName]) + 1);
            }
            else {
                depth = Math.max(depth, 1);
            }
        });
        return depth;
    };
    return walker(treeData);
}
